
const PageProvider = ({
  recordType,
  pageHeader,
  formFields,
  filterFields,
  filterRecords,
  renderRecord,
  click,
  clickUrl,
  formName,
  newRecord,
  journalThreadPageProvider,
  commentThreadPageProvider,
  saveRecord,
  destroy,
  showJournal,
  showComment,
  records
}) => {
  return {
    recordType,
    pageHeader,
    formFields,
    filterFields,
    filterRecords,
    renderRecord,
    click,
    clickUrl,
    formName,
    newRecord,
    journalThreadPageProvider,
    commentThreadPageProvider,
    saveRecord,
    destroy,
    showJournal,
    showComment,
    records
  }
}

export default PageProvider
